// Deployments saved before the copy fields became optional carry these English
// defaults verbatim, and agent definitions persist their display defaults the
// same way, so they are read as "not customized" — otherwise every existing
// widget would keep its English chrome after switching language.
export const LEGACY_WIDGET_COPY = {
  title: "Messages",
  subtitle: "Continue a conversation or start a new one",
  newConversationButton: "Start New Conversation",
  empty: "No conversations yet.",
  chatInputPlaceholder: "Ask me anything...",
  thinking: "Thinking...",
  feedbackPlaceholder: "Add details (optional)",
  feedbackSubmit: "Submit",
  feedbackCancel: "Cancel",
} as const;

export type WidgetCopyKey = keyof typeof LEGACY_WIDGET_COPY;

export function customWidgetCopy(
  value: unknown,
  key: WidgetCopyKey
): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed || trimmed === LEGACY_WIDGET_COPY[key]) return null;
  return value;
}
